import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/components/organism/Filter/types';

export const recyclingRequestFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'customerNickLike',
    label: '닉네임',
    placeholder: '닉네임을 입력해주세요',
  },
  {
    key: 'customerType',
    label: '회원 유형',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '일반', value: 'normal' },
      { label: '사업자', value: 'business' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'createdAt',
    label: '신청 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'requestNameLike',
    label: '보내는 사람',
    placeholder: '이름을 입력해주세요',
  },
  {
    key: 'status',
    type: ListFilterTypeObject.SELECT,
    label: '수거 진행 상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '수거 신청', value: 'REQUEST' },
      {
        label: '수거중',
        value: 'PROCESSING',
      },
      {
        label: '수거취소 - 고객 취소',
        value: 'CANCELED_BY_CUSTOMER',
      },
      {
        label: '수거취소 - 택배사 취소',
        value: 'CANCELED_BY_CARRIER',
      },
      {
        label: '수거취소 - 관리자 취소',
        value: 'CANCELED_BY_ADMIN',
      },
      {
        label: '수거완료',
        value: 'SHIPPING',
      },
      {
        label: '배달완료',
        value: 'COMPLETED',
      },
      {
        label: '부분 수거완료',
        value: 'PARTIAL_COMPLETE',
      },
      {
        label: '미배달',
        value: 'SHIPPING_DELAYED',
      },
      {
        label: '미집하',
        value: 'PROCESS_DELAYED',
      },
    ],
  },
  {
    key: 'reqNoLike',
    label: '수거 번호',
    placeholder: "수거 번호를 입력해주세요 ('-' 제외)",
  },
  {
    key: 'requestPhoneLike',
    label: '수거 신청 핸드폰 번호',
    placeholder: "핸드폰 번호를 입력해주세요 ('-' 제외)",
  },
  {
    key: 'requestAddressLike',
    label: '수거 주소',
    placeholder: '주소를 입력해주세요',
  },
];
